import { ref } from 'vue';

export type MiniAppLocale = 'uk' | 'ru' | 'en';

export const locale = ref<MiniAppLocale>('uk');

export const localeOptions: Array<{
    value: MiniAppLocale;
    label: string;
    shortLabel: string;
}> = [
    { value: 'uk', label: 'Українська', shortLabel: 'UA' },
    { value: 'ru', label: 'Русский', shortLabel: 'RU' },
    { value: 'en', label: 'English', shortLabel: 'EN' },
];

const messages: Record<'ru' | 'en', Record<string, string>> = {
    ru: {
        // «Поповнити онлайн» (2026-10-27).
        'Поповнити онлайн': 'Пополнить онлайн',
        'Оплата через monobank · Apple Pay, Google Pay, картка':
            'Оплата через monobank · Apple Pay, Google Pay, карта',
        'Оплата через {provider}': 'Оплата через {provider}',
        'Не вдалося завантажити. Спробуйте ще раз.':
            'Не удалось загрузить. Попробуйте ещё раз.',
        'Не вдалося почати оплату. Спробуйте ще раз.':
            'Не удалось начать оплату. Попробуйте ещё раз.',
        'Час на оплату минув. Гроші не списано.':
            'Время на оплату истекло. Деньги не списаны.',
        'Оплату скасовано. Гроші не списано.':
            'Оплата отменена. Деньги не списаны.',
        'Банк відхилив оплату: {reason}': 'Банк отклонил оплату: {reason}',
        'Оплата не пройшла. Гроші не списано.':
            'Оплата не прошла. Деньги не списаны.',
        'Баланс поповнено на {amount} ₴': 'Баланс пополнен на {amount} ₴',
        'Баланс мережі': 'Баланс сети',
        Готово: 'Готово',
        'Оплата не пройшла': 'Оплата не прошла',
        'Очікуємо оплату': 'Ожидаем оплату',
        'Завершіть оплату {amount} ₴ на сторінці monobank. Баланс оновиться сам.':
            'Завершите оплату {amount} ₴ на странице monobank. Баланс обновится сам.',
        'Відкрити сторінку оплати ще раз': 'Открыть страницу оплаты ещё раз',
        'Обрати іншу суму': 'Выбрать другую сумму',
        'Можна обрати інший клуб.': 'Можно выбрать другой клуб.',
        'Своя сума, ₴': 'Своя сумма, ₴',
        'Мінімальна сума: {min} ₴': 'Минимальная сумма: {min} ₴',
        'Оплатити {amount} ₴': 'Оплатить {amount} ₴',
        Оплатити: 'Оплатить',
        'Термін дії авторизації Telegram минув. Закрийте та відкрийте Mini App знову.':
            'Срок действия авторизации Telegram истёк. Закройте и откройте Mini App снова.',
        'Не вдалося перевірити вхід через Telegram. Закрийте та відкрийте Mini App знову.':
            'Не удалось проверить вход через Telegram. Закройте и откройте Mini App снова.',
        "Немає з'єднання з сервером. Перевірте інтернет і спробуйте ще раз.":
            'Нет соединения с сервером. Проверьте интернет и попробуйте ещё раз.',
        'Запросити друга': 'Пригласить друга',
        'Бонуси за друзів, які прийдуть у {network}':
            'Бонусы за друзей, которые придут в {network}',
        'Друзі зарахуються вам одразу після реєстрації.':
            'Друзья засчитаются вам сразу после регистрации.',
        'У мережі {network} бонуси за друзів зараз не нараховуються. Друзі все одно зарахуються вам.':
            'В сети {network} бонусы за друзей сейчас не начисляются. Друзья всё равно засчитаются вам.',
        'Коли друг уперше поповнить рахунок або купить щось від {min} ₴, ви отримаєте {rate}% бонусами в клубі, де він заплатив.':
            'Когда друг впервые пополнит счёт или купит что-то от {min} ₴, вы получите {rate}% бонусами в клубе, где он заплатил.',
        'І ще {rate}% від друзів, яких приведе він.':
            'И ещё {rate}% от друзей, которых приведёт он.',
        'Покупка {amount} ₴': 'Покупка {amount} ₴',
        'Поповнення {amount} ₴': 'Пополнение {amount} ₴',
        нараховано: 'начислено',
        'очікує до {date}': 'ожидает до {date}',
        очікує: 'ожидает',
        'понад місячний ліміт': 'сверх месячного лимита',
        скасовано: 'отменено',
        'Скопіювати посилання': 'Скопировать ссылку',
        Поділитися: 'Поделиться',
        Запрошено: 'Приглашено',
        'З них купили': 'Из них купили',
        Нараховано: 'Начислено',
        'Ще {amount} ₴ чекають нарахування.': 'Ещё {amount} ₴ ждут начисления.',
        'Ваші друзі': 'Ваши друзья',
        'Поки нікого. Надішліть посилання, і друзі з’являться тут, щойно зареєструються.':
            'Пока никого. Отправьте ссылку, и друзья появятся здесь, как только зарегистрируются.',
        'З нами з {date}': 'С нами с {date}',
        'Ще не купував': 'Ещё не покупал',
        'Друзі ваших друзів': 'Друзья ваших друзей',
        'Рівень {level}': 'Уровень {level}',
        'Запрошення діє лише для нових гравців, а у вас уже є акаунт.':
            'Приглашение действует только для новых игроков, а у вас уже есть аккаунт.',
        'Ви приєдналися до клубу. Бонус за запрошення не нараховується: ви вже мали акаунт.':
            'Вы присоединились к клубу. Бонус за приглашение не начисляется: у вас уже был аккаунт.',
        'Ви вже в цьому клубі. Запрошення діє лише для нових гравців.':
            'Вы уже в этом клубе. Приглашение действует только для новых игроков.',
        'Грай зі мною в клубах Highlink! Реєструйся за моїм посиланням.':
            'Играй со мной в клубах Highlink! Регистрируйся по моей ссылке.',
        'Посилання скопійовано.': 'Ссылка скопирована.',
        'Не вдалося скопіювати. Утримуйте посилання, щоб скопіювати його.':
            'Не удалось скопировать. Удерживайте ссылку, чтобы скопировать её.',
        'Готуємо ваш простір…': 'Готовим ваше пространство…',
        'Не вдалося відкрити Mini App': 'Не удалось открыть Mini App',
        'Відкрийте застосунок усередині Telegram.':
            'Откройте приложение внутри Telegram.',
        'Запит номера доступний лише в Telegram.':
            'Запрос номера доступен только в Telegram.',
        'Сканер QR недоступний у цій версії Telegram. Оновіть застосунок.':
            'QR-сканер недоступен в этой версии Telegram. Обновите приложение.',
        'Наведіть камеру на QR-код клубу або ПК':
            'Наведите камеру на QR-код клуба или ПК',
        'Підтвердьте номер телефону': 'Подтвердите номер телефона',
        'Щоб автоматично передати номер телефону, натисніть кнопку внизу.':
            'Чтобы автоматически передать номер телефона, нажмите кнопку внизу.',
        'Поділитися номером телефону': 'Поделиться номером телефона',
        'Створити акаунт': 'Создать аккаунт',
        'Крок 1 з 2': 'Шаг 1 из 2',
        'Крок 2 з 2': 'Шаг 2 из 2',
        Назад: 'Назад',
        'Ігрова спільнота': 'Игровое сообщество',
        'Ім’я': 'Имя',
        Прізвище: 'Фамилия',
        Нікнейм: 'Никнейм',
        'Email · необов’язково': 'Email · необязательно',
        'Нікнейм · необов’язково': 'Никнейм · необязательно',
        Пароль: 'Пароль',
        'Змінити пароль': 'Изменить пароль',
        'Придумайте пароль': 'Придумайте пароль',
        'Зберегти пароль': 'Сохранить пароль',
        'Ваш акаунт перенесено в Highlink, баланс збережено. Пароль потрібен, щоб входити на ПК клубу за телефоном, email або нікнеймом.':
            'Ваш аккаунт перенесён в Highlink, баланс сохранён. Пароль нужен, чтобы входить на ПК клуба по телефону, email или никнейму.',
        'Новий пароль': 'Новый пароль',
        'Повторіть новий пароль': 'Повторите новый пароль',
        'Оновити пароль': 'Обновить пароль',
        'Паролі не збігаються.': 'Пароли не совпадают.',
        'Показати пароль': 'Показать пароль',
        'Приховати пароль': 'Скрыть пароль',
        'Потрібен клуб': 'Нужен клуб',
        'Відскануйте QR-код': 'Отсканируйте QR-код',
        'Щоб створити акаунт, спочатку відскануйте QR клубу або ПК. Так ми зрозуміємо, куди вас приєднати.':
            'Чтобы создать аккаунт, сначала отсканируйте QR-код клуба или ПК. Так мы поймём, куда вас присоединить.',
        'Сканувати QR-код': 'Сканировать QR-код',
        'Сканувати QR': 'Сканировать QR',
        'Мої мережі': 'Мои сети',
        'Клуби мережі': 'Клубы сети',
        'Приєднатися до мережі': 'Присоединиться к сети',
        'Щоб приєднатися до першої мережі, відскануйте її QR-код.':
            'Чтобы присоединиться к первой сети, отсканируйте её QR-код.',
        'Доступ обмежено': 'Доступ ограничен',
        Поповнити: 'Пополнить',
        'Поповнення поки недоступне. Будь ласка, поповніть рахунок у адміністратора.':
            'Пополнение пока недоступно. Пожалуйста, пополните счёт у администратора.',
        'Історія операцій': 'История операций',
        // «Історія операцій» (2026-10-28).
        Сьогодні: 'Сегодня',
        Вчора: 'Вчера',
        '{m} хв': '{m} мин',
        '{h} год': '{h} ч',
        '{h} год {m} хв': '{h} ч {m} мин',
        готівкою: 'наличными',
        карткою: 'картой',
        онлайн: 'онлайн',
        компенсація: 'компенсация',
        бонусами: 'бонусами',
        Поповнення: 'Пополнение',
        'Грає зараз на {pc}': 'Играет сейчас на {pc}',
        'Гра на {pc}': 'Игра на {pc}',
        Покупка: 'Покупка',
        'Повернення покупки': 'Возврат покупки',
        'Поповнення скасовано': 'Пополнение отменено',
        Усі: 'Все',
        Витрати: 'Расходы',
        Поповнено: 'Пополнено',
        Витрачено: 'Потрачено',
        'За весь час': 'За всё время',
        'Поки що жодної операції. Тут з’являться поповнення, ігри та покупки з балансу.':
            'Пока ни одной операции. Здесь появятся пополнения, игры и покупки с баланса.',
        'Таких операцій ще немає.': 'Таких операций ещё нет.',
        'Не вдалося завантажити. Спробувати ще':
            'Не удалось загрузить. Попробовать ещё',
        'баланс {amount} ₴': 'баланс {amount} ₴',
        клуб: 'клуб',
        клуби: 'клуба',
        клубів: 'клубов',
        'Ви вже зареєстровані в цьому клубі.':
            'Вы уже зарегистрированы в этом клубе.',
        'Приєднатися до {club}?': 'Присоединиться к {club}?',
        'Це дозволить {club} отримати доступ до:':
            'Это позволит клубу {club} получить доступ к:',
        'Вашого імені, прізвища та аватара': 'Вашему имени, фамилии и аватару',
        'Вашої дати народження': 'Вашей дате рождения',
        'Вашого email і номера телефону': 'Вашему email и номеру телефона',
        Скасувати: 'Отменить',
        'Приєднатися до клубу': 'Присоединиться к клубу',
        'Ви успішно приєдналися до клубу {club}.':
            'Вы успешно присоединились к клубу {club}.',
        'Основний баланс': 'Основной баланс',
        Рівень: 'Уровень',
        Новачок: 'Новичок',
        Досвід: 'Опыт',
        Клуби: 'Клубы',
        бонусів: 'бонусов',
        бонуси: 'бонусы',
        'Адресу не вказано': 'Адрес не указан',
        'Ваші клуби': 'Ваши клубы',
        'Оберіть мережу в меню зліва, щоб переглянути баланс, бонуси та адреси клубів.':
            'Выберите сеть в меню слева, чтобы посмотреть баланс, бонусы и адреса клубов.',
        'У вас ще немає клубів': 'У вас пока нет клубов',
        'Відскануйте QR-код клубу або ПК — і він одразу з’явиться у вашому Highlink ID.':
            'Отсканируйте QR-код клуба или ПК — и он сразу появится в вашем Highlink ID.',
        Мережі: 'Сети',
        'Гравець Highlink': 'Игрок Highlink',
        'Змінити профіль': 'Изменить профиль',
        Закрити: 'Закрыть',
        'Видалити фото': 'Удалить фото',
        Телефон: 'Телефон',
        Зберегти: 'Сохранить',
        'Дані успішно збережено.': 'Данные успешно сохранены.',
        'Пароль успішно оновлено.': 'Пароль успешно обновлён.',
        'Не вдалося зберегти зміни. Перевірте поля.':
            'Не удалось сохранить изменения. Проверьте поля.',
        'Не вдалося зберегти зміни.': 'Не удалось сохранить изменения.',
        'Не вдалося оновити пароль.': 'Не удалось обновить пароль.',
        Налаштування: 'Настройки',
        'Мова застосунку': 'Язык приложения',
        Тема: 'Тема',
        Світла: 'Светлая',
        Темна: 'Тёмная',
        Головна: 'Главная',
        Профіль: 'Профиль',
        'Увімкнути світлу тему': 'Включить светлую тему',
        'Увімкнути темну тему': 'Включить тёмную тему',
        'Дата народження': 'Дата рождения',
        День: 'День',
        Місяць: 'Месяц',
        Рік: 'Год',
        'День народження': 'День рождения',
        'Місяць народження': 'Месяц рождения',
        'Рік народження': 'Год рождения',
        Січень: 'Январь',
        Лютий: 'Февраль',
        Березень: 'Март',
        Квітень: 'Апрель',
        Травень: 'Май',
        Червень: 'Июнь',
        Липень: 'Июль',
        Серпень: 'Август',
        Вересень: 'Сентябрь',
        Жовтень: 'Октябрь',
        Листопад: 'Ноябрь',
        Грудень: 'Декабрь',
        'Наведіть камеру на код': 'Наведите камеру на код',
        'Демо QR від ПК': 'Демо QR от ПК',
        'Не вдалося відкрити камеру. Дозвольте доступ у налаштуваннях браузера.':
            'Не удалось открыть камеру. Разрешите доступ в настройках браузера.',
        'Почати сесію?': 'Начать сессию?',
        'Сесія розпочнеться за ПК {computer}{zone}. Кошти списуватимуться з балансу за тарифом клубу.':
            'Сессия начнётся за ПК {computer}{zone}. Средства будут списываться с баланса по тарифу клуба.',
        ' у зоні {zone}': ' в зоне {zone}',
        'Почати сесію': 'Начать сессию',
        'Спробувати ще раз': 'Попробовать ещё раз',
        'Доступ закрито': 'Доступ закрыт',
        'Вас заблоковано в цьому клубі. Будь ласка, зверніться до адміністратора.':
            'Вы заблокированы в этом клубе. Пожалуйста, обратитесь к администратору.',
        Зрозуміло: 'Понятно',
        'Сесію успішно розпочато.': 'Сессия успешно начата.',
        'Укажіть ім’я.': 'Укажите имя.',
        'Перевірте формат email.': 'Проверьте формат email.',
        'Виберіть дату народження.': 'Выберите дату рождения.',
        'Дата народження має бути в минулому.':
            'Дата рождения должна быть в прошлом.',
        'Пароль має містити щонайменше 8 символів.':
            'Пароль должен содержать не менее 8 символов.',
        'Щось пішло не так.': 'Что-то пошло не так.',
        'Не отримали номер. Спробуйте ще раз.':
            'Не получили номер. Попробуйте ещё раз.',
        'Перевірте ім’я.': 'Проверьте имя.',
        'Перевірте прізвище.': 'Проверьте фамилию.',
        'Цей нікнейм уже використовується.': 'Этот никнейм уже используется.',
        'Цей email уже використовується.': 'Этот email уже используется.',
        'Перевірте дату народження.': 'Проверьте дату рождения.',
        'Перевірте пароль.': 'Проверьте пароль.',
        'Квести й досягнення': 'Квесты и достижения',
        'Завдання дня, нагороди й ваш рівень':
            'Задания дня, награды и ваш уровень',
        'Ваш рівень': 'Ваш уровень',
        'Ще {xp} {currency} до рівня {level}':
            'Ещё {xp} {currency} до уровня {level}',
        'Найвищий рівень клубу': 'Высший уровень клуба',
        Квести: 'Квесты',
        Досягнення: 'Достижения',
        'Сьогодні квестів немає': 'Сегодня квестов нет',
        'Загляньте пізніше: клуб додає нові завдання, і за них дають {currency}.':
            'Загляните позже: клуб добавляет новые задания, и за них дают {currency}.',
        Виконано: 'Выполнено',
        Почнеться: 'Начнётся',
        'У клубі поки немає досягнень': 'В клубе пока нет достижений',
        Отримано: 'Получено',
        'Виконано {n} разів': 'Выполнено {n} раз',
        'Клуб поки не показує квести': 'Клуб пока не показывает квесты',
        'Зіграти {n} {unit}': 'Сыграть {n} {unit}',
        'Прийти {n} {unit}': 'Прийти {n} {unit}',
        'Зробити покупки на {n} ₴': 'Сделать покупки на {n} ₴',
        'Купити «{product}» × {n}': 'Купить «{product}» × {n}',
        'Купити «{product}»': 'Купить «{product}»',
        товар: 'товар',
        'Виконати умову': 'Выполнить условие',
        'у зоні {zone}': 'в зоне {zone}',
        'у {days}': 'по {days}',
        'з {from} до {to}': 'с {from} до {to}',
        'після {time}': 'после {time}',
        год: 'ч',
        шт: 'шт',
        'о {time}': 'в {time}',
        'до {time}': 'до {time}',
        сьогодні: 'сегодня',
        годину: 'час',
        години: 'часа',
        годин: 'часов',
        раз: 'раз',
        рази: 'раза',
        разів: 'раз',
        Нд: 'Вс',
        Пн: 'Пн',
        Вт: 'Вт',
        Ср: 'Ср',
        Чт: 'Чт',
        Пт: 'Пт',
        Сб: 'Сб',
        Звичайне: 'Обычное',
        Рідкісне: 'Редкое',
        Епічне: 'Эпическое',
        Легендарне: 'Легендарное',
    },
    en: {
        // «Поповнити онлайн» (2026-10-27).
        'Поповнити онлайн': 'Top up online',
        'Оплата через monobank · Apple Pay, Google Pay, картка':
            'Pay with monobank · Apple Pay, Google Pay, card',
        'Оплата через {provider}': 'Pay with {provider}',
        'Не вдалося завантажити. Спробуйте ще раз.':
            'Could not load. Please try again.',
        'Не вдалося почати оплату. Спробуйте ще раз.':
            'Could not start the payment. Please try again.',
        'Час на оплату минув. Гроші не списано.':
            'The time to pay has run out. No money was taken.',
        'Оплату скасовано. Гроші не списано.':
            'The payment was cancelled. No money was taken.',
        'Банк відхилив оплату: {reason}':
            'The bank declined the payment: {reason}',
        'Оплата не пройшла. Гроші не списано.':
            'The payment did not go through. No money was taken.',
        'Баланс поповнено на {amount} ₴': 'Balance topped up by {amount} ₴',
        'Баланс мережі': 'Network balance',
        Готово: 'Done',
        'Оплата не пройшла': 'The payment did not go through',
        'Очікуємо оплату': 'Waiting for the payment',
        'Завершіть оплату {amount} ₴ на сторінці monobank. Баланс оновиться сам.':
            'Finish paying {amount} ₴ on the monobank page. The balance updates by itself.',
        'Відкрити сторінку оплати ще раз': 'Open the payment page again',
        'Обрати іншу суму': 'Choose another amount',
        'Можна обрати інший клуб.': 'You can choose another club.',
        'Своя сума, ₴': 'Own amount, ₴',
        'Мінімальна сума: {min} ₴': 'The minimum amount is {min} ₴',
        'Оплатити {amount} ₴': 'Pay {amount} ₴',
        Оплатити: 'Pay',
        'Термін дії авторизації Telegram минув. Закрийте та відкрийте Mini App знову.':
            'Telegram authorization has expired. Close and reopen the Mini App.',
        'Не вдалося перевірити вхід через Telegram. Закрийте та відкрийте Mini App знову.':
            'Could not verify the Telegram sign-in. Close and reopen the Mini App.',
        "Немає з'єднання з сервером. Перевірте інтернет і спробуйте ще раз.":
            'No connection to the server. Check the internet and try again.',
        'Запросити друга': 'Invite a friend',
        'Бонуси за друзів, які прийдуть у {network}':
            'Bonuses for friends who join {network}',
        'Друзі зарахуються вам одразу після реєстрації.':
            'Friends count as yours as soon as they register.',
        'У мережі {network} бонуси за друзів зараз не нараховуються. Друзі все одно зарахуються вам.':
            '{network} does not give bonuses for friends right now. Your friends still count as yours.',
        'Коли друг уперше поповнить рахунок або купить щось від {min} ₴, ви отримаєте {rate}% бонусами в клубі, де він заплатив.':
            'When a friend first tops up or buys something for {min} ₴ or more, you get {rate}% in bonuses at the club where they paid.',
        'І ще {rate}% від друзів, яких приведе він.':
            'Plus {rate}% from the friends they bring.',
        'Покупка {amount} ₴': 'Purchase {amount} ₴',
        'Поповнення {amount} ₴': 'Top-up {amount} ₴',
        нараховано: 'credited',
        'очікує до {date}': 'pending until {date}',
        очікує: 'pending',
        'понад місячний ліміт': 'over the monthly limit',
        скасовано: 'cancelled',
        'Скопіювати посилання': 'Copy link',
        Поділитися: 'Share',
        Запрошено: 'Invited',
        'З них купили': 'Of them bought',
        Нараховано: 'Credited',
        'Ще {amount} ₴ чекають нарахування.':
            '{amount} ₴ more is waiting to be credited.',
        'Ваші друзі': 'Your friends',
        'Поки нікого. Надішліть посилання, і друзі з’являться тут, щойно зареєструються.':
            'Nobody yet. Send your link and friends will appear here as soon as they register.',
        'З нами з {date}': 'With us since {date}',
        'Ще не купував': 'No purchase yet',
        'Друзі ваших друзів': 'Friends of your friends',
        'Рівень {level}': 'Level {level}',
        'Запрошення діє лише для нових гравців, а у вас уже є акаунт.':
            'Invitations are for new players, and you already have an account.',
        'Ви приєдналися до клубу. Бонус за запрошення не нараховується: ви вже мали акаунт.':
            'You joined the club. No invitation bonus is credited: you already had an account.',
        'Ви вже в цьому клубі. Запрошення діє лише для нових гравців.':
            'You are already in this club. Invitations are for new players only.',
        'Грай зі мною в клубах Highlink! Реєструйся за моїм посиланням.':
            'Play with me at Highlink clubs! Sign up through my link.',
        'Посилання скопійовано.': 'Link copied.',
        'Не вдалося скопіювати. Утримуйте посилання, щоб скопіювати його.':
            'Could not copy. Press and hold the link to copy it.',
        'Готуємо ваш простір…': 'Preparing your space…',
        'Не вдалося відкрити Mini App': 'Could not open Mini App',
        'Відкрийте застосунок усередині Telegram.':
            'Open the app inside Telegram.',
        'Запит номера доступний лише в Telegram.':
            'Phone sharing is available only in Telegram.',
        'Сканер QR недоступний у цій версії Telegram. Оновіть застосунок.':
            'The QR scanner is unavailable in this Telegram version. Update the app.',
        'Наведіть камеру на QR-код клубу або ПК':
            'Point the camera at a club or PC QR code',
        'Підтвердьте номер телефону': 'Confirm your phone number',
        'Щоб автоматично передати номер телефону, натисніть кнопку внизу.':
            'Tap the button below to share your phone number automatically.',
        'Поділитися номером телефону': 'Share phone number',
        'Створити акаунт': 'Create account',
        'Крок 1 з 2': 'Step 1 of 2',
        'Крок 2 з 2': 'Step 2 of 2',
        Назад: 'Back',
        'Ігрова спільнота': 'Gaming community',
        'Ім’я': 'First name',
        Прізвище: 'Last name',
        Нікнейм: 'Nickname',
        'Email · необов’язково': 'Email · optional',
        'Нікнейм · необов’язково': 'Nickname · optional',
        Пароль: 'Password',
        'Змінити пароль': 'Change password',
        'Придумайте пароль': 'Create a password',
        'Зберегти пароль': 'Save password',
        'Ваш акаунт перенесено в Highlink, баланс збережено. Пароль потрібен, щоб входити на ПК клубу за телефоном, email або нікнеймом.':
            'Your account has moved to Highlink, and your balance is kept. You need a password to sign in on the club PCs with your phone, email or nickname.',
        'Новий пароль': 'New password',
        'Повторіть новий пароль': 'Repeat new password',
        'Оновити пароль': 'Update password',
        'Паролі не збігаються.': 'Passwords do not match.',
        'Показати пароль': 'Show password',
        'Приховати пароль': 'Hide password',
        'Потрібен клуб': 'Club required',
        'Відскануйте QR-код': 'Scan a QR code',
        'Щоб створити акаунт, спочатку відскануйте QR клубу або ПК. Так ми зрозуміємо, куди вас приєднати.':
            'Scan a club or PC QR code first so we know where to connect your account.',
        'Сканувати QR-код': 'Scan QR code',
        'Сканувати QR': 'Scan QR',
        'Мої мережі': 'My networks',
        'Клуби мережі': 'Network clubs',
        'Приєднатися до мережі': 'Join a network',
        'Щоб приєднатися до першої мережі, відскануйте її QR-код.':
            'Scan its QR code to join your first network.',
        'Доступ обмежено': 'Access restricted',
        Поповнити: 'Top up',
        'Поповнення поки недоступне. Будь ласка, поповніть рахунок у адміністратора.':
            'Top-up is not available yet. Please top up with the club administrator.',
        'Історія операцій': 'Transaction history',
        // «Історія операцій» (2026-10-28).
        Сьогодні: 'Today',
        Вчора: 'Yesterday',
        '{m} хв': '{m} min',
        '{h} год': '{h} h',
        '{h} год {m} хв': '{h} h {m} min',
        готівкою: 'in cash',
        карткою: 'by card',
        онлайн: 'online',
        компенсація: 'compensation',
        бонусами: 'with bonuses',
        Поповнення: 'Top-up',
        'Грає зараз на {pc}': 'Playing now on {pc}',
        'Гра на {pc}': 'Played on {pc}',
        Покупка: 'Purchase',
        'Повернення покупки': 'Purchase refunded',
        'Поповнення скасовано': 'Top-up cancelled',
        Усі: 'All',
        Витрати: 'Spending',
        Поповнено: 'Topped up',
        Витрачено: 'Spent',
        'За весь час': 'All time',
        'Поки що жодної операції. Тут з’являться поповнення, ігри та покупки з балансу.':
            'No transactions yet. Top-ups, games and purchases from the balance will show up here.',
        'Таких операцій ще немає.': 'No such transactions yet.',
        'Не вдалося завантажити. Спробувати ще': 'Could not load. Try again',
        'баланс {amount} ₴': 'balance {amount} ₴',
        клуб: 'club',
        клуби: 'clubs',
        клубів: 'clubs',
        'Ви вже зареєстровані в цьому клубі.':
            'You are already registered with this club.',
        'Приєднатися до {club}?': 'Join {club}?',
        'Це дозволить {club} отримати доступ до:':
            'This will allow {club} to access:',
        'Вашого імені, прізвища та аватара':
            'Your first name, last name and avatar',
        'Вашої дати народження': 'Your date of birth',
        'Вашого email і номера телефону': 'Your email and phone number',
        Скасувати: 'Cancel',
        'Приєднатися до клубу': 'Join club',
        'Ви успішно приєдналися до клубу {club}.':
            'You have successfully joined {club}.',
        'Основний баланс': 'Main balance',
        Рівень: 'Level',
        Новачок: 'Newcomer',
        Досвід: 'Experience',
        Клуби: 'Clubs',
        бонусів: 'bonus',
        бонуси: 'bonus',
        'Адресу не вказано': 'Address not provided',
        'Ваші клуби': 'Your clubs',
        'Оберіть мережу в меню зліва, щоб переглянути баланс, бонуси та адреси клубів.':
            'Choose a network in the left menu to view balances, bonuses and club addresses.',
        'У вас ще немає клубів': 'You have not joined any clubs yet',
        'Відскануйте QR-код клубу або ПК — і він одразу з’явиться у вашому Highlink ID.':
            'Scan a club or PC QR code and it will appear in your Highlink ID.',
        Мережі: 'Networks',
        'Гравець Highlink': 'Highlink player',
        'Змінити профіль': 'Edit profile',
        Закрити: 'Close',
        'Видалити фото': 'Delete photo',
        Телефон: 'Phone',
        Зберегти: 'Save',
        'Дані успішно збережено.': 'Your changes have been saved.',
        'Пароль успішно оновлено.': 'Your password has been updated.',
        'Не вдалося зберегти зміни. Перевірте поля.':
            'Could not save the changes. Check the fields.',
        'Не вдалося зберегти зміни.': 'Could not save the changes.',
        'Не вдалося оновити пароль.': 'Could not update the password.',
        Налаштування: 'Settings',
        'Мова застосунку': 'App language',
        Тема: 'Theme',
        Світла: 'Light',
        Темна: 'Dark',
        Головна: 'Home',
        Профіль: 'Profile',
        'Увімкнути світлу тему': 'Enable light theme',
        'Увімкнути темну тему': 'Enable dark theme',
        'Дата народження': 'Date of birth',
        День: 'Day',
        Місяць: 'Month',
        Рік: 'Year',
        'День народження': 'Birth day',
        'Місяць народження': 'Birth month',
        'Рік народження': 'Birth year',
        Січень: 'January',
        Лютий: 'February',
        Березень: 'March',
        Квітень: 'April',
        Травень: 'May',
        Червень: 'June',
        Липень: 'July',
        Серпень: 'August',
        Вересень: 'September',
        Жовтень: 'October',
        Листопад: 'November',
        Грудень: 'December',
        'Наведіть камеру на код': 'Point the camera at the code',
        'Демо QR від ПК': 'Demo PC QR',
        'Не вдалося відкрити камеру. Дозвольте доступ у налаштуваннях браузера.':
            'Could not open the camera. Allow access in your browser settings.',
        'Почати сесію?': 'Start session?',
        'Сесія розпочнеться за ПК {computer}{zone}. Кошти списуватимуться з балансу за тарифом клубу.':
            'The session will start on PC {computer}{zone}. Your balance will be charged at the club rate.',
        ' у зоні {zone}': ' in the {zone} zone',
        'Почати сесію': 'Start session',
        'Спробувати ще раз': 'Try again',
        'Доступ закрито': 'Access closed',
        'Вас заблоковано в цьому клубі. Будь ласка, зверніться до адміністратора.':
            'You are blocked at this club. Please contact the administrator.',
        Зрозуміло: 'Got it',
        'Сесію успішно розпочато.': 'The session has started.',
        'Укажіть ім’я.': 'Enter your first name.',
        'Перевірте формат email.': 'Check the email format.',
        'Виберіть дату народження.': 'Select your date of birth.',
        'Дата народження має бути в минулому.':
            'The date of birth must be in the past.',
        'Пароль має містити щонайменше 8 символів.':
            'The password must be at least 8 characters.',
        'Щось пішло не так.': 'Something went wrong.',
        'Не отримали номер. Спробуйте ще раз.':
            'We did not receive the number. Try again.',
        'Перевірте ім’я.': 'Check the first name.',
        'Перевірте прізвище.': 'Check the last name.',
        'Цей нікнейм уже використовується.': 'This nickname is already in use.',
        'Цей email уже використовується.': 'This email is already in use.',
        'Перевірте дату народження.': 'Check the date of birth.',
        'Перевірте пароль.': 'Check the password.',
        'Квести й досягнення': 'Quests & achievements',
        'Завдання дня, нагороди й ваш рівень':
            "Today's tasks, rewards and your level",
        'Ваш рівень': 'Your level',
        'Ще {xp} {currency} до рівня {level}':
            '{xp} {currency} more to {level}',
        'Найвищий рівень клубу': "The club's top level",
        Квести: 'Quests',
        Досягнення: 'Achievements',
        'Сьогодні квестів немає': 'No quests today',
        'Загляньте пізніше: клуб додає нові завдання, і за них дають {currency}.':
            'Check back later: the club adds new tasks, and they pay {currency}.',
        Виконано: 'Done',
        Почнеться: 'Starts',
        'У клубі поки немає досягнень': 'The club has no achievements yet',
        Отримано: 'Earned',
        'Виконано {n} разів': 'Done {n} times',
        'Клуб поки не показує квести': "The club doesn't show quests yet",
        'Зіграти {n} {unit}': 'Play {n} {unit}',
        'Прийти {n} {unit}': 'Visit {n} {unit}',
        'Зробити покупки на {n} ₴': 'Spend {n} ₴',
        'Купити «{product}» × {n}': 'Buy “{product}” × {n}',
        'Купити «{product}»': 'Buy “{product}”',
        товар: 'an item',
        'Виконати умову': 'Meet the condition',
        'у зоні {zone}': 'in the {zone} zone',
        'у {days}': 'on {days}',
        'з {from} до {to}': 'from {from} to {to}',
        'після {time}': 'after {time}',
        год: 'h',
        шт: 'pcs',
        'о {time}': 'at {time}',
        'до {time}': 'until {time}',
        сьогодні: 'today',
        годину: 'hour',
        години: 'hours',
        годин: 'hours',
        раз: 'time',
        рази: 'times',
        разів: 'times',
        Нд: 'Sun',
        Пн: 'Mon',
        Вт: 'Tue',
        Ср: 'Wed',
        Чт: 'Thu',
        Пт: 'Fri',
        Сб: 'Sat',
        Звичайне: 'Common',
        Рідкісне: 'Rare',
        Епічне: 'Epic',
        Легендарне: 'Legendary',
    },
};

export function normalizeLocale(value: unknown): MiniAppLocale | null {
    if (typeof value !== 'string') {
        return null;
    }

    const language = value.toLowerCase().split(/[-_]/)[0];

    return language === 'uk' || language === 'ru' || language === 'en'
        ? language
        : null;
}

export function initializeLocale(telegramLanguage?: unknown): void {
    const stored = readStoredLocale();

    applyLocale(stored ?? normalizeLocale(telegramLanguage) ?? 'uk', false);
}

export function applyAccountLocale(
    value: unknown,
    telegramLanguage?: unknown,
): void {
    const accountLocale = normalizeLocale(value);

    if (accountLocale) {
        applyLocale(accountLocale);

        return;
    }

    clearStoredLocale();
    applyLocale(normalizeLocale(telegramLanguage) ?? 'uk', false);
}

export function applyLocale(value: MiniAppLocale, persist = true): void {
    locale.value = value;

    if (typeof document !== 'undefined') {
        document.documentElement.lang = value;
    }

    if (!persist) {
        return;
    }

    try {
        window.localStorage?.setItem('miniapp-locale', value);
    } catch {
        // The account preference still persists through the API.
    }
}

export function t(
    key: string,
    replacements: Record<string, string | number> = {},
): string {
    const translated =
        locale.value === 'uk' ? key : (messages[locale.value][key] ?? key);

    return Object.entries(replacements).reduce(
        (value, [name, replacement]) =>
            value.replaceAll(`{${name}}`, String(replacement)),
        translated,
    );
}

function readStoredLocale(): MiniAppLocale | null {
    try {
        return normalizeLocale(window.localStorage?.getItem('miniapp-locale'));
    } catch {
        return null;
    }
}

function clearStoredLocale(): void {
    try {
        window.localStorage?.removeItem('miniapp-locale');
    } catch {
        // The Telegram preference still applies for the current session.
    }
}
